import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { bindActionCreators, Dispatch } from 'redux';
import { Routes } from '../../constants/routes';

type IProps = Route.IRouteProps & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class AuthRoute extends React.Component<IProps, Route.IRouteState> {
  render() {
    if (!(this.props.Auth && this.props.Auth.token)) {
      return <Redirect to={{ pathname: Routes.Login }} />;
    } else if (this.props.location && this.props.computedMatch && this.props.location.pathname !== this.props.computedMatch.url) {
      return <Redirect to={{ pathname: this.props.computedMatch.url }} />;
    }

    return <Route {...this.props} />;
  }
}

const mapStateToProps = (state: General.Store) => ({ Auth: state.Auth });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({}, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthRoute);
